import templateUrl from "emun.auth/cookie-consent/cookie-consent.htm";
import controller from "emun.auth/cookie-consent/cookie-consent.controller";

export default {
  bindings: {},
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
